module.exports = __webpack_public_path__ + "static/media/backend.9074c8fc.png";